import React from 'react'

import AddPatientNewLayout from 'presentation/doctor/layouts/AddPatientNew'

const AddPatientNew = () => <AddPatientNewLayout />

export default AddPatientNew
